module.exports = __webpack_public_path__ + "img/intro.37ea798c.png";